module.exports = __webpack_public_path__ + "img/inge-v6.fcdc6a09.png";